import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import md5 from 'md5';
import { showError } from 'utils/utils';
import Button from 'components/ui/Button/Button';
import FormGroup from 'components/ui/FormGroup/FormGroup';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface BookSecretProps {
  onClose: () => void;
  onSuccess: () => void;
}

const BookSecret: FC<BookSecretProps> = ({ onClose, onSuccess }) => {
  const [t] = useTranslation();
  const [password, setPassword] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const onClickSubmit = () => {
    const hash = 'e9137a47118a595eaaeb012c2e7ce78e';
    setIsSubmitted(true);

    if (md5(password) === hash) {
      onSuccess();
      onClose();
    } else {
      showError(t('home.wrong_password'));
    }
  };

  return (
    <div className="modal-overlay modal-overlay-top">
      <div className="modal modal-sm active">
        <div className="modal-title">
          <h5 className="title">{t('home.confirmation_dialog')}</h5>
        </div>
        <div className="modal-content">
          <FormGroup
            onChange={setPassword}
            value={password}
            label={t('home.password')}
            validation={{ required: true }}
            isSubmitted={isSubmitted}
          />
        </div>
        <div className="modal-footer">
          <Button title={t('confirm')} onClick={() => onClickSubmit()} />
          <Button title={t('close')} className="btn btn-default" onClick={() => onClose()} />
        </div>
      </div>
    </div>
  );
};

export default withErrorBoundary(BookSecret, 'BookSecret');
